import { isArray, isPlainObject, isString } from 'lodash';
import { TBaseTag, TBaseTagContext } from '../types';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import { TTag } from './types';
import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';
import React from 'react';

const validationScheme: TValidationScheme = {
  type: 'object',
  properties: {
    group: {
      type: 'string',
    },
  },
};

const checkGroup = (child: TBaseTag, group?: string) => {
  if ((child.group && child.group === group) || (!child.group && !group)) return true;
  return false;
};

const filteredChildren = (context: Partial<TBaseTagContext>, tagProps: TTag) => {
  const templateChildren = context.template?.children;
  if (isString(templateChildren)) return templateChildren;
  if (isArray(templateChildren))
    return templateChildren.filter(item =>
      isString(item)
        ? true
        : isPlainObject(item)
        ? checkGroup(item as TBaseTag, tagProps.group)
        : false
    );
  if (isPlainObject(templateChildren))
    return checkGroup(templateChildren as TBaseTag, tagProps.group) ? templateChildren : undefined;
  return undefined;
};

export const CustomChildren: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const result = validate(tagProps, validationScheme);

  const children = !result.isValid ? undefined : filteredChildren(context, tagProps);

  if (!result.isValid) {
    console.error(
      'Тэг: $Children;',
      `Путь: ${context.path?.join('.') || 'Не указан'};`,
      result.errors
    );
    return null;
  }

  return <UniversalChildren context={context}>{children}</UniversalChildren>;
});

CustomChildren.displayName = 'CustomChildren';
